var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('HeaderDesktop'),_c('HeaderMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }